import { render, staticRenderFns } from "./sessionsTable.vue?vue&type=template&id=8675a724"
import script from "./sessionsTable.vue?vue&type=script&lang=js"
export * from "./sessionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports